import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import BTLogo from "@assets/bt-icon-white.svg";
import PulseDesktopCarousel from "@features/pulse/components/desktop/PulseDesktopCarousel";
import PulseMobileCarousel from "@features/pulse/components/mobile/PulseMobileCarousel";
import PulseCloseButton from "@features/pulse/components/PulseCloseButton";
import type { PulsePageProps } from "@features/pulse/utils/types";
import useFeedbackFormUrl from "@hooks/useFeedbackFormUrl";
import { useWindowSize } from "@hooks/useWindowSize";

/**
 * PulseOthersLayout is a React component that renders the layout for the Pulse
 * It displays a carousel of articles and handles navigation between them.
 *
 */
const PulseLayout = ({
  activeArticle,
  sortedPulseArticles,
  handleNavigateLeftCard,
  handleNavigateRightCard,
  offset,
}: PulsePageProps): React.ReactElement => {
  const { isScreenLG } = useWindowSize();
  const sourceUrl = useFeedbackFormUrl();

  if (sortedPulseArticles.length === 0) return <></>;

  if (!isScreenLG) {
    return (
      <PulseMobileCarousel
        sortedPulseArticles={sortedPulseArticles}
        activeArticle={activeArticle}
        handleNavigateRightCard={handleNavigateRightCard}
        handleNavigateLeftCard={handleNavigateLeftCard}
      />
    );
  }

  return (
    <>
      <div className="flex flex-none items-center justify-between px-6 py-2 text-white">
        <Link to={`${RouteFactory.home}?ref=pulse`} reloadDocument>
          <img src={BTLogo} width={200} height={18} alt="The Business Times" />
        </Link>

        <PulseCloseButton
          activeArticle={activeArticle}
          sortedPulseArticles={sortedPulseArticles}
          isDesktop
        />
      </div>

      <PulseDesktopCarousel
        sortedPulseArticles={sortedPulseArticles}
        activeArticle={activeArticle}
        handleNavigateRightCard={handleNavigateRightCard}
        handleNavigateLeftCard={handleNavigateLeftCard}
        offset={offset}
      />

      <div className="flex flex-none justify-between p-6 pt-10 font-poppins text-4xs font-light tracking-2% text-gray-550 lg:block">
        <div className="text-right">
          AI-generated summary.
          <a
            target="_blank"
            href={sourceUrl}
            className="underline-offset-4 hover:underline"
            rel="noreferrer"
          >
            {` Feedback`}
          </a>
        </div>
      </div>
    </>
  );
};

export default PulseLayout;
